module.exports = __webpack_public_path__ + "img/Frame 752.81ad4f9e.png";